"use client"
import { Text } from "@/elements"
import { PauseIcon, PlayIcon, SpeakerWaveIcon, SpeakerXMarkIcon } from "@heroicons/react/24/outline"

import { useInView } from "motion/react"
import { useEffect, useRef, useState } from "react"
import ReactPlayer from "react-player/lazy"

export const VideoSection = () => {
  const [isMounted, setIsMounted] = useState(false)
  const [muted, setMuted] = useState(true)
  const [volume, setVolume] = useState(0.5)
  const [paused, setPaused] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const ref = useRef<HTMLDivElement>(null)
  const inView = useInView(ref)

  //if (!) return <div className="h-[572px] w-full" />

  return (
    <div
      ref={ref}
      className="group relative flex h-[250px] w-full items-center justify-center overflow-hidden rounded-xl md:h-[572px]">
      {isMounted ? (
        <>
          <ReactPlayer
            height={912}
            width={"100%"}
            volume={muted ? 0 : volume}
            loop
            playing={inView && !paused}
            config={{
              vimeo: {
                playerOptions: {
                  playsinline: true,
                },
              },
            }}
            key="video"
            url="https://vimeo.com/947174319/a641aecb0d"
          />
          <div className="absolute bottom-5 left-5 flex flex-col gap-y-2 md:bottom-10 md:left-10">
            <Text className="text-marketing-primary-dark/50">Launch Campaign</Text>
            <Text className="text-marketing-primary-dark" variant="h4">
              What do you need?
            </Text>
          </div>
          <div className="group absolute bottom-0 right-0 flex items-center gap-2 p-5 transition-all group-hover:opacity-100 md:p-10 md:opacity-0">
            {!muted && (
              <input
                type="range"
                min="0"
                max="1"
                step="0.01"
                value={volume}
                onChange={e => setVolume(parseFloat(e.target.value))}
                className="h-1 w-20 cursor-pointer appearance-none rounded-lg bg-marketing-primary-dark/30 opacity-0 group-hover:opacity-100 [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-marketing-primary-dark"
              />
            )}
            <div
              onClick={() => setMuted(p => !p)}
              className="flex size-10 cursor-pointer items-center justify-center rounded-full bg-marketing-primary-dark/10">
              {muted ? (
                <SpeakerXMarkIcon className="size-6 stroke-marketing-primary-dark" />
              ) : (
                <SpeakerWaveIcon className="size-6 stroke-marketing-primary-dark" />
              )}
            </div>
            <div
              onClick={() => setPaused(p => !p)}
              className="flex size-10 cursor-pointer items-center justify-center rounded-full bg-marketing-primary-dark/10">
              {paused ? (
                <PlayIcon className="size-6 stroke-marketing-primary-dark" />
              ) : (
                <PauseIcon className="size-6 stroke-marketing-primary-dark" />
              )}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  )
}
